import { Box, Typography } from "@mui/material";

import { BellIcon } from "../../../components/Icons";
import { NullContainerBox } from "./Notification.style";
import React from "react";

type Props = {
  title: string;
}

const NotificationNullState = (props: Props) => {
  const { title } = props;

  return (
    <>
      <NullContainerBox>
        <Box className="nullContent">
          <BellIcon width={35} height={40}/>
          <Box className="nullText">
            <Typography variant="h4" fontWeight={600}>{title}</Typography>
            <Typography variant="body1" color={"#908E8D"}>
              All clear!</Typography>
            <Typography variant="body1" color={"#908E8D"}>
              You&apos;ve caught up with everything!</Typography>
          </Box>
        </Box>
      </NullContainerBox>

    </>
  );
};

export default NotificationNullState;
